const recordLead = async (params, leadAttribute) => {
    const formData = convertParamsToFormData(params, leadAttribute);

    return fetch(`${APP_DOMAIN}/api/marketing/contact/`, {
        method: "POST",
        credentials: "include",
        body: formData,
    });
};

const convertParamsToFormData = (params, leadAttribute) => {
    const formData = new FormData();

    formData.append("fos_user_registration_form[email]", params.email);
    formData.append("fos_user_registration_form[firstname]", params.firstname);
    formData.append("fos_user_registration_form[lastname]", params.lastname);
    formData.append("fos_user_registration_form[_token]", params.csrfToken);
    if (undefined !== params.organization) {
        formData.append("fos_user_registration_form[organization]", params.organization);
    }

    formData.append("fos_user_registration_form[customAttributes][]", leadAttribute);

    return formData;
};

export default recordLead;
